<template>
    <div>
        <div class="subnavbackground">
            <SavedSearches 
                application="tv-analys" 
                :tabName="$route.meta.tab" 
                :currentFilters="$store.getters[`get${$route.meta.tabQuery}Query`]"
                @close="$store.commit('setExpandSavedSearchesSidebar', false)"
            />
            <b-row v-if="obsMessage" class="obs-message-row">
                <p class="obsText">
                    {{ obsMessage }}
                </p>
            </b-row>
            <b-row class="bottomheader mr-0">
                <button id="tooltip-target-ssasinfo" class="ssasinfobtn">
                    <img class="ssasinfoicon" src="@/assets/images/total-blue.svg" alt="" />
                </button>
                <span class="userinternaltext" v-if="userInternalText()"> {{ userInternalText() }} &#x1F441; </span>
                <b-tooltip v-if="SSASMessage != null || config_CurrentClientVersion != null" target="tooltip-target-ssasinfo" triggers="hover" custom-class="infoTooltip">
                    <p>Client version: {{ config_CurrentClientVersion }}</p>
                    <p>API version: {{ SSASMessage.version }}</p>
                    <p>Model: {{ SSASMessage.linkedSSAS }}</p>
                    <p>Last SSAS processing: {{ SSASMessage.lastProcessed }}</p>
                    <p>First content publish date: {{ SSASMessage.contentPublishedFromDate }}</p>
                    <p>Last content publish date: {{ SSASMessage.contentPublishedToDate }}</p>
                    <p>First ad publish date: {{ SSASMessage.adPublishedFromDate }}</p>
                    <p>Last ad publish date: {{ SSASMessage.adPublishedToDate }}</p>
                </b-tooltip>
                <b-button
                    v-if="config_OldDataUrl && showOldDataButton"
                    v-b-tooltip.hover.right="`Data before ${config_ToV3ChangeDate}`"
                    @click="navigateToOldData"
                    class="ml-1"
                    style="font-size: 0.8rem"
                    size="sm"
                    variant="primary"
                >
                    See older data {{ this.$route.name }}
                </b-button
                >
                <div class="centered">
                    <router-link v-if="config_ShowOverview" to="/overview">Overview</router-link>
                    <router-link to="/programs" v-if="config_ShowProgramTab || config_ExternalProgramTabLink">Program</router-link>
                    <router-link to="/ads" v-if="config_ShowAdTab || config_ExternalCampaignTabLink">Ad</router-link>
                    <router-link to="/channels" v-if="config_ShowChannelTab || config_ExternalChannelTabLink">Channel</router-link>
                </div>
                <div v-if="anyFormFieldsLoaded" class="right d-flex">
                    <b-button 
                        class="savesearchbtn px-2" 
                        variant="primary" 
                        id="tooltip-target-1" 
                        @click="$store.commit('setExpandSavedSearchesSidebar', true)"
                        v-if="showSaveSearchButton"
                    >
                        <i class="bi bi-floppy"></i>
                    </b-button>
                    <b-tooltip target="tooltip-target-1" triggers="hover">
                        Save/load template
                    </b-tooltip>
                    <b-button id="infoButton" v-b-toggle.sidebar-1 class="btn-xs mx-2" variant="primary">
                        <b-icon icon="info-circle" />
                    </b-button>
                    <b-tooltip target="infoButton" triggers="hover" placement="top">
                        View information log
                    </b-tooltip>

                    <b-button id="bookButton" class="btn-xs" variant="info" @click="openInfoLink">
                        <b-icon icon="book" />
                        <span />
                    </b-button>
                    <b-tooltip target="bookButton" triggers="hover" placement="top">
                        Read user manual
                    </b-tooltip>
                </div>
            </b-row>
        </div>

        <b-sidebar id="sidebar-1" right title="Information Log" shadow>
            <div class="px-3 py-2">
                <p class="messageBox" v-html="dataLogMessage" />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import globalConfig from "../../../mixins/globalConfig"
import SavedSearches from "./SavedSearches.vue"
export default {
    mixins: [globalConfig],
    name: "SubNav",
    components: {
        SavedSearches,
    },
    data() {
        return {
            showOldDataButton: false,
        }
    },
    computed: {
        showSaveSearchButton() {
            return this.$store.getters.getShowSaveSearchButton
        },
        dataLogMessage() {
            return this.$store.getters.getDataLogMessage
        },
        obsMessage() {
            return this.$store.getters.getObsMessage
        },
        SSASMessage() {
            return this.$store.getters.getSSASMessage
        },
        anyFormFieldsLoaded() {
            let anyFormFieldsLoaded =
                this.$store.getters.getProgramsInitStatus === "LOADED" || this.$store.getters.getAdsInitStatus === "LOADED" || this.$store.getters.getChannelsInitStatus === "LOADED"
            return anyFormFieldsLoaded
        },
    },
    watch: {
        $route(to) {
            this.setShowOldDataButton(to.path)
            this.setShowSaveSearchButton(to)
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.setShowSaveSearchButton(this.$route)
        this.setShowOldDataButton()
    },
    methods: {
        userInternalText() {
            let userInternalText = ""
            if (this.$store.state.systemInfo.internalAndMMSOnly) userInternalText = "MMS-ONLY"
            return userInternalText
        },
        openInfoLink() {
            window.open("https://mms.se/wp-content/uploads/manual-totalanalys.pdf", "_blank")
        },
        navigateToOldData() {
            window.location.replace(this.config_OldDataUrl)
        },
        setShowSaveSearchButton(route) {
            let showSaveSearchButton = route.meta.tab !== "Overview" && this.config_ShowSaveSearchButton
            this.$store.commit("setShowSaveSearchButton", showSaveSearchButton)
        },
        setShowOldDataButton(path) {
            if (path === "/channels" || path == "/programs") {
                this.showOldDataButton = true
            } else {
                this.showOldDataButton = false
            }
        },
    },
}
</script>

<style scoped>
.savesearchbtn {
    height: 1.7rem;
    padding-top: .6rem;
    display: flex;
    align-items: center;
}
.messageBox {
    border: 1px solid #dee2e6 !important;
    background-color: #eee;
    margin-bottom: 0;
    padding: 10px;
    font-size: small;
    color: #2c3e50 !important;
    text-align: left;
    white-space: pre-line;
}
>>> .userinternaltext {
    color: red;
}
a {
    text-transform: uppercase;
    margin: 5px 20px;
    position: relative;
    display: inline-block;
    color: #337ab7;
}
.router-link-exact-active {
    font-weight: bold;
}
.centered {
    position: absolute;
    left: 50%;
    right: 50%;
    padding-top: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
}
.right {
    margin-right: 1rem;
    margin-left: auto;
}
.clientinfotv {
    background: none;
    border: none;
    padding: 0;
    cursor: default;
    margin-left: 1rem;
}
.btn-xs {
    padding: 0.25rem 0.4rem;
    font-size: 0.875rem;
    line-height: 0.5;
    border-radius: 0.2rem;
}
.ssasinfobtn {
    background: none;
    border: none;
    margin-left: 1rem;
    margin-right: 0.2rem;
}
.ssasinfoicon {
    width: 1.5rem;
    border: darkslategray;
}
>>> .tooltip-inner {
    font-size: smaller;
    text-align: left;
    min-width: 7rem;
}
.subnavbackground {
    height: auto;
}
.obs-message-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #fff;
    padding: 0 16px 0 16px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    border-bottom: 1px solid #225380;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-right: 0;
}
.obsText {
    margin-left: 18px;
    margin-bottom: 0;
    padding: 5px 0;
    letter-spacing: 0.25px;
    color: #ff8c00;
    font-size: 0.9em;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    overflow-wrap: break-word;
    text-align: center;
}
.bottomheader {
    border-bottom: 1px dotted #aaa;
    height: 40px !important;
    padding: 5px 16px;
    align-items: center;
    background-color: #fff;
}
</style>
